import { createSelector } from 'reselect'
import { getDiamondsInCart, getJewelryInCart, getDiamondPrices, getJewelryPrices } from './cart'
import _ from 'lodash'
import { roundTo } from '../utils'

const getTaxRate = state => state.cart.taxPercent * 0.01
const getCustomDepositAmount = state => state.cart.customDepositAmount
const getDiamondDepositRate = state => state.cart.diamondDepositRate
const getJewelryDepositRate = state => state.cart.jewelryDepositRate
const getSessionCurrency = state => state.settings.currency

export const getDiamondsForCheckout = createSelector(
  [ getDiamondsInCart ],
  (diamondsInCart) => _.pickBy(diamondsInCart, (diamond) => diamond.checkout)
)

export const getJewelryForCheckout = createSelector(
  [ getJewelryInCart ],
  (jewelryInCart) => _.pickBy(jewelryInCart, (jewelry) => jewelry.checkout)
)

export const getNumCheckoutItems = createSelector(
  [ getDiamondsForCheckout, getJewelryForCheckout ],
  (diamondsForCheckout, jewelryForCheckout) => Object.keys(diamondsForCheckout).length + Object.keys(jewelryForCheckout).length
)

export const getPreTaxDiamondPrice = createSelector(
  [ getDiamondsForCheckout, getDiamondPrices ],
  (diamonds, diamondPrices) => {
    let preTaxDiamondTotal = _.keys(diamonds).reduce((sum, diamondId) => sum + roundTo(parseFloat(diamondPrices[diamondId]), 2), 0)
    return roundTo(preTaxDiamondTotal, 2)
  }
)

export const getPreTaxJewelryPrice = createSelector(
  [ getJewelryForCheckout, getJewelryPrices, getSessionCurrency ],
  (jewelry, jewelryPrices, sessionCurrency) => {
    let preTaxJewelryTotal = _.keys(jewelry).reduce((sum, jewelryId) => {
      let preTaxJewelryPrice = (parseFloat(jewelryPrices[jewelryId]) + parseFloat(jewelry[jewelryId][`appraisalCostIn${sessionCurrency.toUpperCase()}`]))
      return sum + roundTo(preTaxJewelryPrice, 2)
    }, 0)
    return roundTo(preTaxJewelryTotal, 2)
  }
)

export const getJewelryTaxAmount = createSelector(
  [ getJewelryForCheckout, getJewelryPrices, getSessionCurrency, getTaxRate ],
  (jewelry, jewelryPrices, sessionCurrency, taxRate) => {
    let taxAmount = _.keys(jewelry).reduce((sum, jewelryId) => {
      let preTaxJewelryPrice = (parseFloat(jewelryPrices[jewelryId]) + parseFloat(jewelry[jewelryId][`appraisalCostIn${sessionCurrency.toUpperCase()}`]))
      return sum + (roundTo(preTaxJewelryPrice, 2) * taxRate)
    }, 0)
    return roundTo(taxAmount, 2)
  }
)

export const getDiamondTaxAmount = createSelector(
  [ getDiamondsForCheckout, getDiamondPrices, getTaxRate ],
  (diamonds, diamondPrices, taxRate) => {
    let taxAmount = _.keys(diamonds).reduce((sum, diamondId) => {
      let preTaxDiamondPrice = roundTo(parseFloat(diamondPrices[diamondId]), 2)
      return sum + (roundTo(preTaxDiamondPrice, 2) * taxRate)
    }, 0)
    return roundTo(taxAmount, 2)
  }
)

export const getSubtotal = createSelector(
  [ getPreTaxDiamondPrice, getPreTaxJewelryPrice ],
  (preTaxDiamondPrice, preTaxJewelryPrice) => {
    return roundTo(parseFloat(preTaxDiamondPrice) + parseFloat(preTaxJewelryPrice), 2)
  }
)

export const getTaxAmount = createSelector(
  [ getJewelryTaxAmount, getDiamondTaxAmount ],
  (jewelryTaxAmount, diamondTaxAmount) => {
    return roundTo(jewelryTaxAmount + diamondTaxAmount, 2)
  }
)

export const getGrandTotal = createSelector(
  [ getSubtotal, getTaxAmount ],
  (subtotal, taxAmount) => {
    return roundTo(subtotal + taxAmount, 2)
  }
)

export const getTotalDiamondPrice = createSelector(
  [ getPreTaxDiamondPrice, getDiamondTaxAmount ],
  (preTaxDiamondPrice, diamondTaxAmount) => {
    return roundTo(preTaxDiamondPrice + diamondTaxAmount, 2)
  }
)

export const getTotalJewelryPrice = createSelector(
  [ getPreTaxJewelryPrice, getJewelryTaxAmount ],
  (preTaxJewelryPrice, jewelryTaxAmount) => {
    return roundTo(preTaxJewelryPrice + jewelryTaxAmount, 2)
  }
)

export const getDepositAmount = createSelector(
  [ getCustomDepositAmount,
    getTotalDiamondPrice,
    getTotalJewelryPrice,
    getDiamondDepositRate,
    getJewelryDepositRate ],
  (customDepositAmount, diamondPrice, jewelryPrice, diamondDepositRate, jewelryDepositRate) => {
    if (_.isNumber(customDepositAmount)) return roundTo(customDepositAmount, 2)
    let diamondDepositAmount = roundTo(diamondPrice * diamondDepositRate, 2)
    let jewelryDepositAmount = roundTo(jewelryPrice * jewelryDepositRate, 2)
    return roundTo(diamondDepositAmount + jewelryDepositAmount, 0)
  }
)



// WEBPACK FOOTER //
// ./src/selectors/summary.js